import React from 'react';
import { LabelProps } from 'recharts';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { BASE_FONT_SIZE, colors } from '@/styles';

const ReferenceLineLabel: React.FC<LabelProps & { applyAxisPadding?: boolean }> = props => {
  const { value, offset, viewBox, applyAxisPadding = false } = props;

  const { y } = viewBox as {
    y: number;
  }; /* NOTE: these definitely exist in viewBox on inspection, so casting it. */

  return (
    <text
      x={applyAxisPadding ? BASE_FONT_SIZE * 11.5 : BASE_FONT_SIZE * 8}
      y={y + BASE_FONT_SIZE} // keep this close to the reference line
      textAnchor="end"
      offset={offset}
      fontSize={BASE_FONT_SIZE}
      // the color override below is needed as the fill gets over ridden within the library
      css={css`
        fill: ${token('color.text.danger', colors.R300)} !important;
      `}
    >
      {value}
    </text>
  );
};

export default ReferenceLineLabel;
